import React, { useEffect, useRef, useState } from "react";
import { ActionMenu } from "oolib";
import { handleDeleteCol, handleDuplicateCol, handleInsertColAfter, handleInsertColBefore, handleClearColContent } from "../../../handlers/handleColActions";
import { UIContent } from "@/UIContent";
import { commonRowColActionMenuStyles } from "../styled";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import styled from "styled-components";

const StyledCustomSelectCompWrapper = styled.button`
  ${commonRowColActionMenuStyles}
  width: 2.5rem;
`;

export const ColActionsMenu = ({
  value,
  colIdx,
  onChange,
  id, 
  defaultColWidth,
  setActionsActiveOnCol,
  colActionsButtonHeight,
  conditionsToRender = true
}) => {

  const [actionMenuIsOpen, setActionMenuIsOpen] = useState(false)

  const isFirstMount = useRef(true)
  useEffect(() => {
    if(!isFirstMount.current){
      setActionsActiveOnCol(actionMenuIsOpen ? colIdx : undefined)
    }else{
      isFirstMount.current = false
    }
  },[actionMenuIsOpen])

  // cuz if an actionmenu is open we want it to continue showing
  // on screen irrespective of other factors such as hover and such
  return (conditionsToRender || actionMenuIsOpen) && (
    <div style={{zIndex: 2, position: 'absolute', top: 0, left: '50%', transform: 'translate(-50%, -50%)'}}>
    <ActionMenu
        popOutOfOverflowHiddenParent
        setShowActions={bool => setActionMenuIsOpen(bool)}
        align="left"
        CustomSelectComp={({ active, onClick }) => {
          return (
            <StyledCustomSelectCompWrapper style={{ height: colActionsButtonHeight+'px'}} onClick={onClick}
            active={active}>
              <DisplayIcon
                icon="DotsThree"
                size={16}
              />
            </StyledCustomSelectCompWrapper>
          );
        }}
        actions={[
          {
            display: UIContent.SimpleTable.delete,
            onClick: () => handleDeleteCol({ value, colIdx, onChange, id }),
          },
          {
            display: UIContent.SimpleTable.duplicate,
            onClick: () => handleDuplicateCol({ value, colIdx, onChange, id }),
          },
          {
            display: UIContent.SimpleTable.insertColAfter,
            onClick: () => handleInsertColAfter({ value, colIdx, onChange, id, defaultColWidth }),
          },
          {
            display: UIContent.SimpleTable.insertColBefore,
            onClick: () => handleInsertColBefore({ value, colIdx, onChange, id, defaultColWidth }),
          },
          {
            display: UIContent.SimpleTable.clearContent,
            onClick: () => handleClearColContent({ value, colIdx, onChange, id, defaultColWidth }),
          }
        ]}
      />
  </div>
  );
};


